import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HLDisplayCheckoutUtilService {
  private skipAdminFee = new BehaviorSubject<boolean>(false);
  private skipBrokenBoxFee = new BehaviorSubject<boolean>(false);

  constructor() {}

  public emitSkipAdminFeeEvent(skipAdminFee: boolean): void {
    this.skipAdminFee.next(skipAdminFee);
  }

  public getSkipAdminFeeObservable(): Observable<boolean> {
    return this.skipAdminFee.asObservable();
  }

  public emitSkipBrokenBoxFeeEvent(skipBrokenBoxFee: boolean): void {
    this.skipBrokenBoxFee.next(skipBrokenBoxFee);
  }
  public getSkipBrokenBoxFeeObservable(): Observable<boolean> {
    return this.skipBrokenBoxFee.asObservable();
  }
}
